import { render, staticRenderFns } from "./TraxUiAjaxForm.vue?vue&type=template&id=14695371"
import script from "./TraxUiAjaxForm.vue?vue&type=script&lang=js"
export * from "./TraxUiAjaxForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports